(() => {
  if (window.SMGiftBox) return;
  const models = new WeakMap();
  const sourceForm = (form) => form.dataset.smGiftParent ? document.getElementById(form.dataset.smGiftParent) || form : form;
  const modelFor = (form) => {
    const source = sourceForm(form);
    const panel = source.querySelector('[data-sm-gift-box]');
    if (!panel) return null;
    if (!models.has(panel)) {
      let variants = [];
      try { variants = JSON.parse(panel.querySelector('[data-sm-gift-variants]').textContent); } catch (error) { return null; }
      models.set(panel, { source, panel, variants, checkbox: panel.querySelector('[data-sm-gift-check]') });
    }
    return models.get(panel);
  };
  const stateFor = (form) => {
    const model = modelFor(form);
    if (!model) return null;
    const id = String(new FormData(model.source).get('id') || '');
    const variant = model.variants.find((item) => String(item.id) === id);
    const eligible = Boolean(variant?.available && Number(variant.price) <= Number(model.panel.dataset.priceLimit));
    const quantity = Math.max(1, Math.floor(Number(new FormData(model.source).get('quantity')) || 1));
    return { ...model, variant, eligible, quantity, selected: eligible && model.checkbox.checked };
  };
  const sync = (form) => {
    const state = stateFor(form);
    if (!state) return;
    const { panel, checkbox, source, eligible } = state;
    panel.hidden = !eligible;
    checkbox.disabled = !eligible;
    if (!eligible) checkbox.checked = false;
    const selected = eligible && checkbox.checked;
    panel.classList.toggle('is-selected', selected);
    source.querySelectorAll('[data-sm-standard-checkout]').forEach((element) => { element.hidden = selected; });
    source.querySelectorAll('[data-sm-gift-checkout]').forEach((element) => { element.hidden = !selected; });
  };
  const build = (form) => {
    const state = stateFor(form);
    if (!state?.selected) return new FormData(form);
    const data = new FormData(state.source);
    const result = new FormData();
    for (const [key, value] of data.entries()) {
      if (key === 'id' || key === 'selling_plan' || key.startsWith('properties[')) {
        const path = key.replace(/\]/g, '').split('[');
        result.append(`items[0][${path.join('][')}]`, value);
      }
    }
    result.set('items[0][quantity]', String(state.quantity));
    result.set('items[1][id]', state.panel.dataset.giftVariant);
    result.set('items[1][quantity]', String(state.quantity));
    const variantTitle = state.variant.title === 'Default Title' ? '' : ` — ${state.variant.title}`;
    result.set(`items[1][properties][${state.panel.dataset.giftForLabel}]`, `${state.panel.dataset.productTitle}${variantTitle}`);
    result.set('items[1][properties][_sm_gift_for_variant]', String(state.variant.id));
    return result;
  };
  window.SMGiftBox = { build, selected: (form) => Boolean(stateFor(form)?.selected), sync };
  const ready = () => document.querySelectorAll('[data-sm-gift-box]').forEach((panel) => { const form = panel.closest('form'); if (form) sync(form); });
  document.addEventListener('change', (event) => { const form = event.target.closest('form'); if (form) sync(form); });
  document.addEventListener('input', (event) => { if (event.target.name !== 'quantity') return; const form = event.target.closest('form'); if (form) sync(form); });
  document.addEventListener('shopify:section:load', ready);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
